import Layout from 'components/Layout/Layout';
import React from 'react';
import Card from '@material-ui/core/Card';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Home from './Home/Home';
import About from './About/About';
import WhenToUse from './WhenToUse/WhenToUse';
import Contact from './Contact/Contact';
import Doctors from './Doctors/Doctors';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function Content() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Layout>
      <Tabs value={value} onChange={handleChange} aria-label="content tabs">
        <Tab label="English" {...a11yProps(0)} />
        <Tab label="Arabic" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">Home</Typography>
          <Home locale="en" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">About</Typography>
          <About locale="en" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">When to use</Typography>
          <WhenToUse locale="en" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">Contact Us</Typography>
          <Contact locale="en" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">Doctors</Typography>
          <Doctors locale="en" />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">Home</Typography>
          <Home locale="ar" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">About</Typography>
          <About locale="ar" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">When to use</Typography>
          <WhenToUse locale="ar" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">Contact Us</Typography>
          <Contact locale="ar" />
        </Card>
        <Card sx={{ mb: 2, p: 3 }}>
          <Typography variant="h4">Doctors</Typography>
          <Doctors locale="ar" />
        </Card>
      </TabPanel>
    </Layout>
  );
}

export default Content;
